import React, { useState } from 'react';
import styled, { useTheme } from 'styled-components/macro';
import { IoMdEye, IoMdEyeOff } from 'react-icons/io';

const INPUT_TYPE_PASSWORD = 'password';
const INPUT_TYPE_TEXT = 'text';
const ENTER_KEY = 'Enter';

const Input = styled.input`
  height: 36px;
  margin: 12px 0 12px 0px;
  max-width: 800px;
  width: 100%;
  border-radius: 4px;
  padding: 0 8px;
  border: none;
  display: block;
  font-size: 16px;
  &::placeholder {
    font-size: 16px;
    color: ${props => props.theme.colors.black[100]};
    opacity: 0.6;
    font-family: 'Work Sans, sans-serif';
    font-weight: 500;
  }
  border: 'none';
  box-sizing: border-box;
  transition:
    border-color 0.15s ease-in-out,
    box-shadow 0.15s ease-in-out;
  &:focus {
    color: #495057;
    background-color: #fff;
    border-color: #80bdff;
    outline: 0;
  }
`;

const EyeField = styled.div`
  position: absolute;
  right: 10px;
  top: 20px;
  cursor: pointer;
`;

const PasswordContainer = styled.div`
  position: relative;
  margin-bottom: 32px;
  > span {
    color: ${props => props.theme.colors.danger[100]};
    font-size: 12px;
    margin: -28px 0 12px 0;
    opacity: 0.8;
  }
`;

type Props = {
  onChange: (password: string) => void;
  onEnter?: () => void;
  error?: string;
  password?: string;
};

export const PasswordInput = ({
  password,
  error,
  onChange,
  onEnter,
}: Props) => {
  const themes = useTheme();
  const [passwordView, setPasswordView] = useState<string>(INPUT_TYPE_PASSWORD);

  const handleKeyDown = (event: React.KeyboardEvent) => {
    if (event.key === ENTER_KEY) {
      onEnter && onEnter();
    }
  };

  return (
    <PasswordContainer>
      <Input
        onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
          onChange(event.target.value)
        }
        onKeyDown={handleKeyDown}
        type={passwordView}
        value={password}
      />
      {error && <span>{error}</span>}
      <EyeField
        onClick={() => {
          setPasswordView(
            passwordView === INPUT_TYPE_PASSWORD
              ? INPUT_TYPE_TEXT
              : INPUT_TYPE_PASSWORD
          );
        }}
      >
        {passwordView === INPUT_TYPE_PASSWORD ? (
          <IoMdEyeOff size={24} color={themes.colors.neutral[80]} />
        ) : (
          <IoMdEye size={24} color={themes.colors.neutral[80]} />
        )}
      </EyeField>
    </PasswordContainer>
  );
};
